import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Sidebar } from './components/layout/Sidebar';
import { Topbar } from './components/layout/Topbar';
import { Dashboard } from './components/dashboard/Dashboard';
import { ProfilePage } from './pages/ProfilePage';
import { MyWorksPage } from './pages/MyWorksPage';
import { RoyaltyManagementPage } from './pages/RoyaltyManagementPage';
import { BookDetailPage } from './pages/BookDetailPage';
import { PublicBookPage } from './pages/PublicBookPage';
import { ContractManagementPage } from './pages/ContractManagementPage';
import { ExplorePage } from './pages/ExplorePage';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { OnboardingPage } from './pages/OnboardingPage';
// Ensure both CSS files are imported
import './styles.css';
import './index.css';
// Interfaces for component props
interface LayoutProps {
  children: React.ReactNode;
}
// Layout with sidebar and topbar for app pages
function AppLayout({
  children
}: LayoutProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <div className="flex flex-col lg:flex-row h-screen w-full bg-gray-50/80" data-id="element-0">
      <Sidebar isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} data-id="element-1" />
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-2">
        <Topbar isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} data-id="element-3" />
        <main className="flex-1 overflow-auto p-3 sm:p-4 md:p-6" data-id="element-4">
          {children}
        </main>
      </div>
    </div>;
}
// Layout for public pages without sidebar and topbar
function PublicLayout({
  children
}: LayoutProps) {
  return <div className="min-h-screen bg-gray-50/80" data-id="element-5">{children}</div>;
}
export function App() {
  return <BrowserRouter data-id="element-6">
      <Routes data-id="element-7">
        <Route path="/login" element={<LoginPage data-id="element-9" />} data-id="element-8" />
        <Route path="/signup" element={<SignupPage data-id="element-11" />} data-id="element-10" />
        <Route path="/onboarding" element={<OnboardingPage data-id="element-13" />} data-id="element-12" />
        <Route path="/" element={<AppLayout data-id="element-15">
              <Dashboard data-id="element-16" />
            </AppLayout>} data-id="element-14" />
        <Route path="/dashboard" element={<AppLayout data-id="element-18">
              <Dashboard data-id="element-19" />
            </AppLayout>} data-id="element-17" />
        <Route path="/my-works" element={<AppLayout data-id="element-21">
              <MyWorksPage data-id="element-22" />
            </AppLayout>} data-id="element-20" />
        <Route path="/explore" element={<AppLayout data-id="element-24">
              <ExplorePage data-id="element-25" />
            </AppLayout>} data-id="element-23" />
        {/* IMPORTANT: The more specific route must come first */}
        <Route path="/book/public/:bookId" element={<PublicLayout data-id="element-27">
              <PublicBookPage data-id="element-28" />
            </PublicLayout>} data-id="element-26" />
        <Route path="/book/:bookId" element={<AppLayout data-id="element-30">
              <BookDetailPage data-id="element-31" />
            </AppLayout>} data-id="element-29" />
        <Route path="/royalty-management" element={<AppLayout data-id="element-33">
              <RoyaltyManagementPage data-id="element-34" />
            </AppLayout>} data-id="element-32" />
        <Route path="/contract-management" element={<AppLayout data-id="element-36">
              <ContractManagementPage data-id="element-37" />
            </AppLayout>} data-id="element-35" />
        <Route path="/profile" element={<PublicLayout data-id="element-39">
              <ProfilePage data-id="element-40" />
            </PublicLayout>} data-id="element-38" />
        <Route path="/profile/:authorId" element={<PublicLayout data-id="element-42">
              <ProfilePage data-id="element-43" />
            </PublicLayout>} data-id="element-41" />
        <Route path="*" element={<Navigate to="/" replace data-id="element-45" />} data-id="element-44" />
      </Routes>
    </BrowserRouter>;
}
// Function to navigate to internal book page - standardized navigation
const goToInternalPage = () => {
  navigate(`/book/${bookId}`);
};
// Set isNewUser flag when redirecting from onboarding
const completeOnboarding = () => {
  sessionStorage.setItem('isNewUser', 'true');
  navigate('/dashboard');
};